import React from "react";

const CardManagementList = React.lazy(() => import('src/pages/card_management/CardManagementList'));
const AddCardManagement = React.lazy(() => import('src/pages/card_management/AddCardManagement'));
const EditCardManagement = React.lazy(() => import('src/pages/card_management/EditCardManagement'));
const ViewCardManagement = React.lazy(() => import('src/pages/card_management/ViewCardManagement'));

const routes = [
    { path: '/dashboard/card-management-list/add', name: 'Add', element: AddCardManagement },
    { path: '/dashboard/card-management-list/edit', name: 'Edit', element: EditCardManagement },
    { path: '/dashboard/card-management-list/view/:id', withParam: true, exact: true, name: "", element: ViewCardManagement },
    { path: '/dashboard/card-management-list', name: 'Card Management', element: CardManagementList },
];

export default routes;